import { createUseStyles, Styles } from '@pff-consumer/tweed-ui/web-styles'

interface OneStepCheckoutStyles {
  oneStepCheckoutContainer: Styles
  header: Styles
  separator: Styles
  paymentMethodsContainer: Styles
  paymentMethodsContainerWithApplePay: Styles
  loginLink: Styles
}

const CHECKOUT_CONTAINER_MAX_WIDTH = 406

export const useStyles = createUseStyles<OneStepCheckoutStyles>((theme) => {
  return {
    oneStepCheckoutContainer: {
      marginTop: theme.calcUnit(theme.spacing.s8),
      marginBottom: theme.calcUnit(theme.spacing.s1),
      display: 'flex',
      flexDirection: 'column',
      maxWidth: theme.calcUnit(CHECKOUT_CONTAINER_MAX_WIDTH),
    },
    header: {
      marginBottom: theme.calcUnit(theme.spacing.s5),
    },
    separator: {
      marginTop: theme.calcUnit(theme.spacing.s5),
    },
    paymentMethodsContainer: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: theme.spacing.s3,
    },
    paymentMethodsContainerWithApplePay: {
      gridTemplateColumns: '1fr 1fr 1fr',
    },
    loginLink: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: theme.calcUnit(theme.spacing.s8 - theme.spacing.s1),
      marginBottom: theme.calcUnit(theme.spacing.s5),
    },
  }
})
